import { AutoColumn } from 'components/Column'
import { SwitchLocaleLink } from 'components/SwitchLocaleLink'
import { useEffect, useState } from 'react'
import { Route, Switch, Redirect, useRouteMatch } from 'react-router-dom'
import styled from 'styled-components/macro'
import { useActiveWeb3React } from '../../hooks/web3'
import { NewIncentivePage } from './NewIncentivePage'
import { PageTitle } from '../../components/PageTitle'
import { RedirectDuplicateTokenStakingIds } from './redirects'
import { useWalletModalToggle } from '../../state/application/hooks'
import { Helmet } from 'react-helmet'

const PageWrapper = styled(AutoColumn)`
  max-width: 1350px;
  width: 100%;

  ${({ theme }) => theme.mediaWidth.upToMedium`
    max-width: 800px;
  `};

  ${({ theme }) => theme.mediaWidth.upToSmall`
    max-width: 600px;
  `};
`
const InnerWrapper = styled(AutoColumn)`
  ${({ theme }) => theme.mediaWidth.upToSmall`{
    min-width: 100%;
  }`}
`
const MainContentWrapper = styled.div`
  border-radius: 20px;
  display: flex;
  flex-direction: column;
  ${({ theme }) => theme.mediaWidth.upToSmall`{
    min-width: 100%;
  }`}
`

export default function LimitFarmingPage() {
  const { account } = useActiveWeb3React()

  const [now, setNow] = useState(Date.now())

  useEffect(() => {
    const timeNow = setInterval(() => setNow(Date.now()), 1000)
    return () => {
      clearInterval(timeNow)
    }
  }, [])

  const { path } = useRouteMatch()

  const toggleWalletModal = useWalletModalToggle()

  return (
    <>
      <Helmet>
        <title>Algebra — Farming</title>
      </Helmet>
      <PageWrapper>
        <InnerWrapper gap="lg" justify="center">
          <InnerWrapper gap="lg" style={{ width: '100%', gridRowGap: '0' }}>
            <MainContentWrapper>
              <Switch>
                <Route exact path={`${path}`}>
                  <Redirect to={`${path}/${account ? 'create-event' : ''}`} />
                </Route>
                <Route
                  exact
                  strict
                  render={(props) => (
                    <>
                      <Helmet>
                        <title>Algebra — Farming • Create event</title>
                      </Helmet>
                      <PageTitle title={'Create event'}></PageTitle>
                      <NewIncentivePage {...props}></NewIncentivePage>
                    </>
                  )}
                  path={`${path}/create-event`}
                ></Route>
                <Route
                  exact
                  strict
                  render={(props) => (
                    <>
                      <Helmet>
                        <title>Algebra — Farming • Create event</title>
                      </Helmet>
                      <PageTitle title={'Create event'}></PageTitle>
                      <RedirectDuplicateTokenStakingIds {...props}></RedirectDuplicateTokenStakingIds>
                    </>
                  )}
                  path={`${path}/create-event/:currencyIdA?/:currencyIdB?/:rewardTokenId?/:bonusRewardTokenId?/:lockedTokenId?`}
                ></Route>
              </Switch>
            </MainContentWrapper>
          </InnerWrapper>
        </InnerWrapper>
      </PageWrapper>
      <SwitchLocaleLink />
    </>
  )
}
